<template>
  <div class="add-hemorrhage public-content">
    <div class="breadcrumb">上传素材</div>
    <div class="third-title"><span>素材</span></div>
    <div class="order-detail-basic">
      <el-form :model="elementVo" :rules="rules" label-width="100px" ref="formRef">
        <el-form-item label="素材标签:" prop="labelIds">
          <el-checkbox-group v-model="elementVo.labelIds">
            <el-checkbox v-for="item in tageList" :key="item.id" :label="item.id">{{ item.label }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="素材:">
          <input id="update" multiple @change="uploadImg" type="file" style="display:none">
          <el-button type="primary" @click="clickInput" round>上传</el-button>
          <div style="margin-top:10px;">
            <div class="upload_warp_img">
              <div class="upload_warp_img_div" v-for="(item, index) of elementVo.elementImages" :key="index">
                <div class="upload_img">
                  <img :src="item">
                  <!-- <el-image :src="item" :fit="contain"></el-image> -->
                </div>
                <div class="upload_warp_img_div_top">
                  <p class="upload_warp_img_div_del color-blue" @click="elementVo.elementImages.splice(index, 1)">删除图片</p>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="背景契合度:" prop="fitId">
          <el-select clearable v-model="elementVo.fitId" placeholder="请选择">
            <el-option v-for="item in bgFitList" :key="item.id" :label="item.dictValue" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="前端是否显示:">
          <el-switch v-model="elementVo.isShow" :active-value='1' :inactive-value='0' active-color="rgba(20, 115, 230, 1)" inactive-color="rgba(140, 140, 140, 1)">
          </el-switch>
        </el-form-item>
      </el-form>
    </div>
    <div class="form-btn" style="margin: 20px 0">
      <el-button round type="primary" @click="add">确定</el-button>
    </div>
  </div>
</template>
 <script>
import uploadWebImg, { getAwsSdk } from '@/utils/uploadWebImg.js'
import { labelGetLabelList, elementSetAdd, elementBgFit } from '@/api/pms'
export default {
  name: 'add-hemorrhage',
  data () {
    return {
      awsSdk: null,
      checkList: [],
      elementVo: {
        fitId: '',
        elemType: this.$route.query.elemType,
        elementImages: [],
        isShow: 0,
        labelIds: []
      },
      searchLabelVo: {
        label: '',
        labelBelong: '',
        labelBelongCode: this.$route.query.elemType,
        page: 0
      },
      tageList: [],
      bgFitList: [],
      rules: {
        labelIds: [
          { type: 'array', required: true, message: '请至少选择一个素材标签', trigger: 'change' }
        ],
        fitId: [
          { required: true, message: '请选择背景契合度', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    if (this.$checkAwsSdk('product')) this.$store.dispatch('awsSdk/getAwsSdk', 'product')
    this.getTaglist()
    this.getBgFit()
  },
  methods: {
    // 获取背景默认项
    getBgFit () {
      elementBgFit().then(res => {
        if (res.data.success) {
          this.bgFitList = res.data.data
        }
      })
    },
    async uploadImg (e) {
      if (e.target.files[0].type !== 'image/jpeg' && e.target.files[0].type !== 'image/png') {
        this.$message.error('请上传jpeg/png格式的图片')
        return
      }
      if (e.target.files[0].size > 1024 * 1024 * 10) {
        this.$message.error('图片大小不能超过10M')
        return
      }
      for (let i = 0; i < e.target.files.length; i++) {
        await uploadWebImg(e.target.files[i], this.$store.state.awsSdk.product.s3).then(res => {
          this.elementVo.elementImages.push(res)
        })
      }
    },
    clickInput () {
      document.getElementById('update').click()
    },
    add () {
      this.$refs.formRef.validate((valid) => {
        if (!valid) {
          return
        }
        if (this.elementVo.elementImages.length === 0) {
          this.$message.error('素材未上传')
          return
        }
        elementSetAdd(this.elementVo).then(res => {
          if (res.data.success) {
            this.$message.success('创建成功')
            this.$router.go(-1)
          }
        })
      })
    },
    // 获取素材标签
    getTaglist () {
      labelGetLabelList({ pageNum: 1, pageSize: 10, searchLabelVo: this.searchLabelVo }).then(res => {
        if (res.data.success) {
          this.tageList = res.data.data.records
        }
      })
    }
  }
}
</script>
 <style scoped lang="less">
 @deep: ~">>>";
 
 .bg_box {
   display: flex;
   flex-flow: column;
   justify-content: space-around;
   float: left;
   width: 170px;
   height: 170px;
   border: 1px solid #000;
   margin: 5px 5px 0 0;
   position: relative;
 
   .img_box {
     flex: 1;
     // height: 142px;
     display: flex;
     flex-flow: column;
     justify-content: space-around;
   }
 
   .delete_btn {
     border-top: 1px #000 solid;
     // position: absolute;
     // bottom: 0;
     width: 100%;
     // background: red;
     text-align: center;
   }
 }
 
 .add-hemorrhage {
   .spec-mm {
     span {
       margin-right: 10px;
     }
 
     .el-input {
       width: 110px;
     }
 
     @{deep} .el-input-group__append {
       padding: 0 15px;
     }
   }
 
   .link {
     width: 30px;
     height: 30px;
     border: 1px solid #dcdfe6;
     display: flex;
     align-items: center;
     justify-content: center;
     border-radius: 4px;
     box-sizing: border-box;
 
     i {
       font-size: 20px;
       color: #999;
     }
   }
 
   .active-link {
     background: #1473e6;
     border: 1px solid #1473e6;
 
     i {
       color: #fff;
     }
   }
 }
 
 .upload_warp_img {
   overflow: hidden;
   display: flex;
 
   .upload_warp_img_div {
     width: 180px;
     margin: 0 5px;
     border: 1px solid #d2d2d2;
     display: flex;
     flex-flow: column;
     justify-content: space-between;
     height: 200px;
   }
 }
 
 .upload_img {
   flex: 1;
   position: relative;
 
   img {
     position: absolute;
     max-width: 100%;
     max-height: 100%;
     top: 0;
     bottom: 0;
     left: 0;
     right: 0;
     margin: auto;
   }
 }
 
 .upload_warp_img_div_top {
   display: flex;
   width: 100%;
   align-items: center;
   background: #f9fafc;
   justify-content: center;
   line-height: 36px;
   border-top: 1px solid #ececec;
 }
 
 .upload_warp_img_div_del {
   padding-left: 10px;
 }
 </style>
